import OptionLogo200 from "@/assets/imgs/rachman-sons-logo-gold-200h.webp"
import OptionLogo400 from "@/assets/imgs/rachman-sons-logo-gold-400h.webp"
import MainLogo from "./MainLogo";

const Loader = ({ children }) => {
  return (
    <div className="">
      <MainLogo onLoadingPage />
      {children}
      {/* <div className="progress-bar mx-auto mt-4">
        <div className="progress-bar-fill"></div>
      </div> */}
    </div>
  );
};

export default Loader;
